import { render } from "./promotionSettlement.vue?vue&type=template&id=e58fb170&scoped=true"
import script from "./promotionSettlement.vue?vue&type=script&lang=js"
export * from "./promotionSettlement.vue?vue&type=script&lang=js"

import "./promotionSettlement.vue?vue&type=style&index=0&id=e58fb170&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58fb170"]])

export default __exports__